var poll_header_default = {
  "title": "JNo-L",
  "image": "P-0DA",
  "webview": "bfRGJ"
};
export {
  poll_header_default as default
};
//# sourceMappingURL=poll-header-scss.js.map
